import React, { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    try {
      const stored = sessionStorage.getItem('com_admin_session');
      return stored ? JSON.parse(stored) : null;
    } catch {
      return null;
    }
  });

  const login = (username, password) => {
    const validUser = process.env.REACT_APP_ADMIN_USER;
    const validPass = process.env.REACT_APP_ADMIN_PASSWORD;
    const adminName = process.env.REACT_APP_ADMIN_NAME || 'Administrador';

    if (username === validUser && password === validPass) {
      const session = { username, name: adminName, loginAt: new Date().toISOString() };
      sessionStorage.setItem('com_admin_session', JSON.stringify(session));
      setUser(session);
      return { ok: true };
    }
    return { ok: false, error: 'Usuario o contraseña incorrectos' };
  };

  const logout = () => {
    sessionStorage.removeItem('com_admin_session');
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, isAuth: !!user }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);